<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7hCUoO/tc-custom/9781609944568.jpg?1737543876494" alt="This image is the cover for the book Unite and Conquer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Unite and Conquer
      </h1>
      <p class="bookDescription body article font2">
        <p>Old-school divide-and-conquer tactics‚Äîdemonizing opponents, frightening voters, refusing to compromise‚Äîmay make us feel good about the purity of our ideals, but it's no way to get anything done. Worse, this approach betrays some of the most cherished ideals of the progressive movement: inclusion, reason, justice, and hope. Illuminated by examples from her own work and a host of campaigns across the country, Kyrsten Sinema shows how to forge connections‚Äîboth personal and political‚Äîwith seemingly unlikely allies and define our values, interests, and objectives in ways that broaden our range of potential partners and expand our tactical options. With irreverent humor, enthralling campaign stories, and solid, practical advice, Sinema enables us to move past ‚Äúpolitics as war‚Äù and build support for progressive causes on the foundation of our common humanity. <br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kyrsten Sinema, Janet Napolitano
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Berrett-Koehler Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?18fd4cf2